import { render, staticRenderFns } from "./ManufactureProductSpecsList.vue?vue&type=template&id=7428e2e4&scoped=true&"
import script from "./ManufactureProductSpecsList.vue?vue&type=script&lang=js&"
export * from "./ManufactureProductSpecsList.vue?vue&type=script&lang=js&"
import style0 from "./ManufactureProductSpecsList.vue?vue&type=style&index=0&id=7428e2e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7428e2e4",
  null
  
)

export default component.exports